import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ActionedInventoryMoveRequestOverviewQueryVariables = Types.Exact<{
  input: Types.InventoryMoveRequestInput;
}>;


export type ActionedInventoryMoveRequestOverviewQuery = { readonly __typename?: 'Query', readonly inventoryMoveRequest: { readonly __typename?: 'InventoryMoveRequest', readonly id: string, readonly status: Types.InventoryMoveRequestStatus, readonly createdAt: string, readonly actionedAt?: string | null, readonly actionerNotes?: string | null, readonly requestor: { readonly __typename?: 'User', readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null }, readonly actioner?: { readonly __typename?: 'User', readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null } | null, readonly receivingLocation: { readonly __typename?: 'Location', readonly name: string }, readonly skus: { readonly __typename?: 'InventoryMoveRequestSkuPaged', readonly items: ReadonlyArray<{ readonly __typename?: 'InventoryMoveRequestSku', readonly id: string, readonly quantityRequested: number, readonly sku: { readonly __typename?: 'Sku', readonly id: string, readonly name: string, readonly externalReferences: ReadonlyArray<{ readonly __typename?: 'SkuExternalReference', readonly origin: string }> }, readonly fulfillments: ReadonlyArray<{ readonly __typename?: 'InventoryMoveRequestFulfillment', readonly id: string, readonly quantityFulfilled: number, readonly fulfillingLot: { readonly __typename?: 'Lot', readonly expiryDate: string } }> }> } } };


export const ActionedInventoryMoveRequestOverviewDocument = gql`
    query actionedInventoryMoveRequestOverview($input: InventoryMoveRequestInput!) {
  inventoryMoveRequest(input: $input) {
    id
    status
    createdAt
    requestor {
      person {
        firstname
        lastname
      }
    }
    actionedAt
    actionerNotes
    actioner {
      person {
        firstname
        lastname
      }
    }
    receivingLocation {
      name
    }
    skus {
      items {
        id
        quantityRequested
        sku {
          id
          name
          externalReferences {
            origin
          }
        }
        fulfillments {
          id
          quantityFulfilled
          fulfillingLot {
            expiryDate
          }
        }
      }
    }
  }
}
    `;

/**
 * __useActionedInventoryMoveRequestOverviewQuery__
 *
 * To run a query within a React component, call `useActionedInventoryMoveRequestOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionedInventoryMoveRequestOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionedInventoryMoveRequestOverviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActionedInventoryMoveRequestOverviewQuery(baseOptions: Apollo.QueryHookOptions<ActionedInventoryMoveRequestOverviewQuery, ActionedInventoryMoveRequestOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionedInventoryMoveRequestOverviewQuery, ActionedInventoryMoveRequestOverviewQueryVariables>(ActionedInventoryMoveRequestOverviewDocument, options);
      }
export function useActionedInventoryMoveRequestOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionedInventoryMoveRequestOverviewQuery, ActionedInventoryMoveRequestOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionedInventoryMoveRequestOverviewQuery, ActionedInventoryMoveRequestOverviewQueryVariables>(ActionedInventoryMoveRequestOverviewDocument, options);
        }
export type ActionedInventoryMoveRequestOverviewQueryHookResult = ReturnType<typeof useActionedInventoryMoveRequestOverviewQuery>;
export type ActionedInventoryMoveRequestOverviewLazyQueryHookResult = ReturnType<typeof useActionedInventoryMoveRequestOverviewLazyQuery>;
export type ActionedInventoryMoveRequestOverviewQueryResult = Apollo.QueryResult<ActionedInventoryMoveRequestOverviewQuery, ActionedInventoryMoveRequestOverviewQueryVariables>;